import React from "react";
import video from "../../Assets/video.mp4";
import Home from "../Home/Home";

const Background = () => {
  return (
    <div className="main">
      <div className="overlay"></div>
      <video src={video} autoPlay loop muted />
      <div className="content">
        <Home></Home>
      </div>
    </div>
  );
};

export default Background;
